import * as recurring from "./recurring";
import * as historical from "./historical";
import dynamicEvents from "./dynamicEvents"; // adjust path if needed

export const importantEvents = [
  ...Object.values(recurring).flat(),
  ...Object.values(historical).flat(),
  ...dynamicEvents
];